/** 브라우저 로컬 타임존 기준 달력 날짜 (YYYY-MM-DD) */
export function formatLocalDateYmd(d: Date = new Date()): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

/** ISO date-time 등에서 앞 10자 YYYY-MM-DD만 추출 (형식 불일치 시 null) */
export function extractYmdPrefix(raw: string): string | null {
    const head = raw.trim().slice(0, 10);
    return /^\d{4}-\d{2}-\d{2}$/.test(head) ? head : null;
}
